import { LEAD_COLLECTOR_STEPS, useFetchForm, VIEW_TYPE } from '@entities/leadCollector';
import { useUpdateEventMutation } from '@pages/event/api/useUpdateEventMutation';
import { useToast } from '@shared/hooks/useToast';
import { EditIcon } from '@shared/assets/icons';
import { Button } from '@shared/ui/kit';
import { useParams } from 'react-router-dom';
import { Tooltip } from '@shared/ui/tooltip';
import * as stylex from '@stylexjs/stylex';
import { styles } from './styles';

interface FormHeaderProps {
  title?: string;
  onPreviewTemplate: (viewType: number) => void;
  viewType: number;
  setStep: (step: number) => void;
  hasGeneratedLinks: boolean;
  formId?: number;
  prevStep: number;
}

export const FormHeader = ({
  title,
  onPreviewTemplate,
  viewType,
  setStep,
  hasGeneratedLinks,
  formId,
  prevStep,
}: FormHeaderProps) => {
  const [, updateEvent] = useUpdateEventMutation();
  const { showToast } = useToast();
  const { id } = useParams();
  const { refetch } = useFetchForm(Number(formId));

  const handleChooseForm = async () => {
    if (!id || !formId) return;

    const { error } = await updateEvent({ id: Number(id), formId: formId });

    if (error) {
      showToast('Произошла ошибка', 'error');
      return;
    }

    setStep(LEAD_COLLECTOR_STEPS.CREATE_LINKS);
  };

  const handleEditForm = () => {
    refetch();
    onPreviewTemplate(VIEW_TYPE.CONSTRUCTOR);
  };

  return (
    <div {...stylex.props(styles.container)}>
      <span {...stylex.props(styles.title)}>Шаблон «{title}»</span>

      {viewType === VIEW_TYPE.PREVIEW_CONSTRUCTOR ? (
        <Button
          size="small"
          variant="primary"
          settings={{ padding: '8px 20px', fontSize: '14px' }}
          onClick={() => onPreviewTemplate(VIEW_TYPE.CONSTRUCTOR)}
        >
          Вернуться к редактированию
        </Button>
      ) : (
        <div {...stylex.props(styles.headerActions)}>
          <Tooltip
            position="left"
            disabled={!hasGeneratedLinks}
            {...stylex.props(styles.tooltipContainer)}
            title={
              <span {...stylex.props(styles.tooltipText)}>
                Редактирование запрещено, форма уже отправлена участникам
              </span>
            }
          >
            <div>
              <Button
                size="small"
                variant="secondary"
                settings={{ width: '36px', height: '36px' }}
                onClick={handleEditForm}
                isDisabled={hasGeneratedLinks}
              >
                <EditIcon />
              </Button>
            </div>
          </Tooltip>

          <Button
            size="small"
            variant="secondary"
            settings={{ padding: '8px 20px', fontSize: '14px' }}
            onClick={() => setStep(prevStep)}
          >
            Вернуться к списку
          </Button>

          <Button
            size="small"
            variant="accent"
            settings={{ padding: '8px 20px', fontSize: '14px' }}
            onClick={handleChooseForm}
            isDisabled={hasGeneratedLinks}
          >
            Выбрать шаблон
          </Button>
        </div>
      )}
    </div>
  );
};
